(function() {
  function loadScript(src) {
    return new Promise(function(resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = function() { reject(new Error('Failed to load: ' + src)); };
      document.head.appendChild(s);
    });
  }

  loadScript('https://www.gstatic.com/firebasejs/10.12.2/firebase-app-compat.js')
    .then(function() {
      return loadScript('https://www.gstatic.com/firebasejs/10.12.2/firebase-database-compat.js');
    })
    .then(function() {
      initChat();
    })
    .catch(function(err) {
      console.error('Firebase SDK load error:', err);
    });

  function initChat() {
    var root = document.getElementById('dkChat');
    var panel = document.getElementById('dkPanel');
    var trigger = document.getElementById('dkTrigger');
    var close = document.getElementById('dkClose');
    var body = document.getElementById('dkBody');
    var input = document.getElementById('dkInput');
    var send = document.getElementById('dkSend');
    var plus = document.getElementById('dkPlus');
    var fileInput = document.getElementById('dkFileInput');
    var startOverlay = document.getElementById('dkStartOverlay');
    var startBtn = document.getElementById('dkStartBtn');
    var endOverlay = document.getElementById('dkEndOverlay');
    var endYes = document.getElementById('dkEndYes');
    var endNo = document.getElementById('dkEndNo');
    var uploadPreview = document.getElementById('dkUploadPreview');
    var statusText = document.getElementById('dkStatus');
    var startSubtitle = document.getElementById('dkStartSubtitle');
    var dragOverlay = document.getElementById('dkDragOverlay');

    /* ─── ენა + ლექსიკონი ───
       ენას სექცია გადმოსცემს: <div class="dk-chat" data-lang="ka|en"> */
    var DK_LANG = (root && root.dataset.lang === 'en') ? 'en' : 'ka';

    var DK_T = {
      ka: {
        welcome:      'გამარჯობა 💚',
        statusOnline: 'ონლაინ კონსულტაცია',
        statusHours:  'სამუშაო საათები: 10:00 - 22:00',
        replySoon:    '2-3 წუთში გიპასუხებთ 🫡',
        deleted:      'წაშლილია შეტყობინება',
        del:          'წაშლა',
        maxPhotos:    'მაქსიმუმ 20 ფოტო შეგიძლია.',
        tooLarge:     'სურათი 5MB-ზე მეტია: ',
        chatClosed:   'ჩატი დასრულებულია',
        mapTitle:     'თბილისი მოლი',
        mapSubtitle:  'სავაჭრო ცენტრი',
        seen:         'Seen',
        blocked:      'ჩატი მიუწვდომელია'
      },
      en: {
        welcome:      'Hello 💚',
        statusOnline: 'Online consultation',
        statusHours:  'Working hours: 10:00 - 22:00',
        replySoon:    'We reply in 2-3 minutes 🫡',
        deleted:      'Message deleted',
        del:          'Delete',
        maxPhotos:    'You can attach up to 20 photos.',
        tooLarge:     'Image is larger than 5MB: ',
        chatClosed:   'Chat ended',
        mapTitle:     'Tbilisi Mall',
        mapSubtitle:  'Shopping mall',
        seen:         'Seen',
        blocked:      'Chat unavailable'
      }
    };

    function t(key) {
      return (DK_T[DK_LANG] || DK_T.ka)[key] || '';
    }

// Scroll isolation — chat panel
body.addEventListener('wheel', function(e) {
  var atTop = body.scrollTop === 0;
  var atBottom = body.scrollTop + body.clientHeight >= body.scrollHeight - 1;
  if ((e.deltaY < 0 && atTop) || (e.deltaY > 0 && atBottom)) {
    e.preventDefault();
  }
  e.stopPropagation();
}, { passive: false });

// Touch scroll isolation — mobile
var touchStartY = 0;
body.addEventListener('touchstart', function(e) {
  touchStartY = e.touches[0].clientY;
}, { passive: true });

body.addEventListener('touchmove', function(e) {
  var dy = e.touches[0].clientY - touchStartY;
  var atTop = body.scrollTop === 0;
  var atBottom = body.scrollTop + body.clientHeight >= body.scrollHeight - 1;
  if ((dy > 0 && atTop) || (dy < 0 && atBottom)) {
    e.preventDefault();
  }
  e.stopPropagation();
}, { passive: false });

    var firebaseConfig = {
      apiKey: "AIzaSyBFi-7ttYgJED-yFctbLTov6BH7J6MOVdI",
      authDomain: "dkhl-dshb.firebaseapp.com",
      databaseURL: "https://dkhl-dshb-default-rtdb.europe-west1.firebasedatabase.app",
      projectId: "dkhl-dshb",
      storageBucket: "dkhl-dshb.firebasestorage.app",
      messagingSenderId: "901410753652",
      appId: "1:901410753652:web:9537d747bd368f7f2dd521",
      measurementId: "G-7E7405XDQ8"
    };

    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig);
    }

    var db = firebase.database();

    var STORAGE_KEYS = {
      sessionId: 'dk_chat_session_id',
      visitorName: 'dk_chat_visitor_name',
      started: 'dk_chat_started'
    };

    function generateSessionId() {
      return 'sess_' + Math.random().toString(36).slice(2) + '_' + Date.now();
    }

    var sessionId = localStorage.getItem(STORAGE_KEYS.sessionId);
    if (!sessionId) {
      sessionId = generateSessionId();
      localStorage.setItem(STORAGE_KEYS.sessionId, sessionId);
    }

    var visitorName = localStorage.getItem(STORAGE_KEYS.visitorName);
    if (!visitorName) {
      visitorName = 'DKHL-' + sessionId.slice(-6);
      localStorage.setItem(STORAGE_KEYS.visitorName, visitorName);
    }

    var chatStarted = localStorage.getItem(STORAGE_KEYS.started) === 'true';
   var selectedImageData = [];
    var lastSentAt = localStorage.getItem('dk_chat_last_sent_at') ? parseInt(localStorage.getItem('dk_chat_last_sent_at')) : null;
    var typingTimeout = null;
    var typingLastSent = 0; // ✅ throttle-ისთვის

    /* ─── ბლოკის მდგომარეობა ──────────────────────────────────
       'hide'   → ვიჯეტი საერთოდ არ ჩანს (ჩუმი ბლოკი)
       'silent' → ვიჯეტი ჩანს, მაგრამ წერა გამორთულია          */
    var DK_BLOCK_MODE = 'hide';
    var isBlocked = false;

    function blockKey(name) {
      return String(name || '').replace(/[.#$\/\[\]]/g, '_');
    }

    function applyBlockState(blocked) {
      isBlocked = blocked;

      if (!blocked) {
        root.style.display = '';
        input.disabled = !chatStarted;
        plus.disabled = !chatStarted;
        updateWorkingHoursStatus();
        refreshSendState();
        return;
      }

      clearTimeout(typingTimeout);
      clearTimeout(openWorkTimer);
      getMetaRef().update({ visitorTyping: false }).catch(function() {});
      detachListeners();
      panel.classList.remove('active');
      root.classList.remove('dk-open');
      document.body.style.overflow = '';

      if (DK_BLOCK_MODE === 'hide') {
        root.style.display = 'none';
      } else {
        input.disabled = true;
        plus.disabled = true;
        send.disabled = true;
        input.value = '';
        input.style.height = 'auto';
        clearImagePreview();
        if (statusText) statusText.textContent = t('blocked');
        if (startSubtitle) startSubtitle.textContent = t('blocked');
      }
    }

    var initialMessageText = t('welcome');
    var initialLoadDone = false;
    var initialRenderBatch = false;   // true, სანამ ძველი მესიჯები ერთად ირისება
    var openWorkTimer = null;         // მძიმე სამუშაოს გადადება ანიმაციის შემდეგ
    var renderedMessageIds = new Set();
    var messagesListenerAttached = false;
    var metaListenerAttached = false;

    function getChatRef() {
      return db.ref('websiteChats/' + sessionId);
    }

    function getMessagesRef() {
      return getChatRef().child('messages');
    }

    function getMetaRef() {
      return getChatRef().child('meta');
    }

    function esc(s) {
      return String(s).replace(/[&<>"']/g, function(m) {
        return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m];
      });
    }

    /* ─── პროდუქტის ფასის ფორმატირება ─────────────────────── */
    function formatProductPrice(price, currency) {
      var num = typeof price === 'number' ? price : parseFloat(price);
      if (!isFinite(num) || num <= 0) return '';
      var symbol = (currency === 'USD') ? '$' : (currency === 'EUR') ? '€' : '₾';
      return symbol + num.toFixed(2);
    }

    function isSafeLinkHref(href) {
  return /^https?:\/\//i.test(href);
}

function linkifyTextInto(el, text) {
  var regex =
    /((?:https?:\/\/|www\.)[^\s<>"']+|(?:localhost|\d{1,3}(?:\.\d{1,3}){3})(?::\d+)?(?:\/[^\s<>"']*)?|(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?::\d+)?(?:\/[^\s<>"']*)?)/gi;

  var str = String(text || "");
  var lastIndex = 0;

  str.replace(regex, function(match, _p1, offset) {
    if (offset > lastIndex) {
      el.appendChild(document.createTextNode(str.slice(lastIndex, offset)));
    }

    var cleanUrl = match.replace(/[.,!?;:)\]]+$/, "");
    var punctuation = match.slice(cleanUrl.length);

    var href =
      cleanUrl.indexOf("http://") === 0 || cleanUrl.indexOf("https://") === 0
        ? cleanUrl
        : "https://" + cleanUrl;

    if (isSafeLinkHref(href)) {
      var a = document.createElement("a");
      a.href = href;
      a.target = "_blank";
      a.rel = "noopener noreferrer nofollow";
      a.className = "dk-chat-link";
      a.textContent = cleanUrl;
      a.addEventListener("click", function(e) {
        e.stopPropagation();
      });
      el.appendChild(a);
    } else {
      el.appendChild(document.createTextNode(cleanUrl));
    }

    if (punctuation) {
      el.appendChild(document.createTextNode(punctuation));
    }

    lastIndex = offset + match.length;
    return match;
  });

  if (lastIndex < str.length) {
    el.appendChild(document.createTextNode(str.slice(lastIndex)));
  }
}

function createLinkifiedDiv(className, text) {
  var div = document.createElement("div");
  div.className = className;
  linkifyTextInto(div, text);
  return div;
}

var DK_TYPE_SPEED = 18; // ms ერთ სიმბოლოზე
var dkReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function typewriteElement(el, delay) {
  if (!el) return;

  var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
  var nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);

  var chars = [];
  nodes.forEach(function(node) {
    var frag = document.createDocumentFragment();
    // Array.from — ემოჯი და surrogate pair არ იხლიჩება
    Array.from(node.nodeValue).forEach(function(ch) {
      var sp = document.createElement('span');
      sp.className = 'dk-ch';
      sp.textContent = ch;
      frag.appendChild(sp);
      chars.push(sp);
    });
    node.parentNode.replaceChild(frag, node);
  });

  if (!chars.length) return;

  if (dkReducedMotion) {
    chars.forEach(function(c) { c.classList.add('is-on'); });
    return;
  }

  // delay — მილიწამებში; სიმბოლოები მაშინვე იმალება, წერა გვიან იწყება
  var startAt = null, shown = 0;
  function step(ts) {
    if (startAt === null) startAt = ts + (delay || 0);
    if (ts < startAt) { requestAnimationFrame(step); return; }
    var target = Math.min(chars.length, Math.floor((ts - startAt) / DK_TYPE_SPEED) + 1);
    while (shown < target) { chars[shown].classList.add('is-on'); shown++; }
    if (shown < chars.length) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

    function bottom() {
      requestAnimationFrame(function() {
        body.scrollTop = body.scrollHeight;
      });
    }

function refreshSendState() {
  var hasText = !!input.value.trim();
  var hasImages = selectedImageData.length > 0;
  send.disabled = isBlocked || !chatStarted || (!hasText && !hasImages);
}

function updateWorkingHoursStatus() {
  if (isBlocked) return;

  var now = new Date();

  var georgiaTime = new Date(
    now.toLocaleString('en-US', { timeZone: 'Asia/Tbilisi' })
  );

  var hour = georgiaTime.getHours();
  var isOpen = hour >= 10 && hour < 22;

  root.classList.toggle('dk-offline', !isOpen);

  if (statusText) {
    statusText.textContent = isOpen ? t('statusOnline') : t('statusHours');
  }

  if (startSubtitle) {
    startSubtitle.textContent = isOpen ? t('replySoon') : t('statusHours');
  }
}

function clearImagePreview() {
  selectedImageData = [];
  var scroll = document.getElementById('dkUploadPreviewScroll');
  if (scroll) scroll.innerHTML = '';
  uploadPreview.classList.add('hidden');
  fileInput.value = '';
  refreshSendState();
}

function addImageThumb(dataUrl, index) {
  var scroll = document.getElementById('dkUploadPreviewScroll');
  var thumb = document.createElement('div');
  thumb.className = 'dk-upload-preview-thumb';
  thumb.setAttribute('data-index', index);
  var img = document.createElement('img');
  img.src = dataUrl;
  var removeBtn = document.createElement('button');
  removeBtn.className = 'dk-upload-remove';
  removeBtn.type = 'button';
  removeBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none"><path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
img.style.cursor = 'pointer';
  img.addEventListener('click', function(e) {
    if (psMoved) return;
    e.stopPropagation();
    openImageLightbox(img.src);
  });

  img.addEventListener('touchstart', function(e) {
    psMoved = false;
  }, { passive: true });

  removeBtn.onclick = function(e) {
    e.stopPropagation();
    e.preventDefault();
    selectedImageData.splice(index, 1);
    rebuildPreviews();
    if (selectedImageData.length === 0) uploadPreview.classList.add('hidden');
    refreshSendState();
  };

  thumb.appendChild(img);
  thumb.appendChild(removeBtn);
  scroll.appendChild(thumb);
}

function rebuildPreviews() {
  var scroll = document.getElementById('dkUploadPreviewScroll');
  scroll.innerHTML = '';
  selectedImageData.forEach(function(dataUrl, i) {
    addImageThumb(dataUrl, i);
  });
}

    function autoResize() {
      input.style.height = 'auto';
      input.style.height = Math.min(input.scrollHeight, 110) + 'px';
      refreshSendState();
    }

    function showEndOverlay() {
      endOverlay.classList.add('active');
    }

    function hideEndOverlay() {
      endOverlay.classList.remove('active');
    }


    function setChatStarted(started) {
      chatStarted = started;
      localStorage.setItem(STORAGE_KEYS.started, started ? 'true' : 'false');

      input.disabled = !started || isBlocked;
      plus.disabled = !started || isBlocked;

      if (started) {
        startOverlay.classList.add('hidden');
      } else {
        startOverlay.classList.remove('hidden');
      }

      refreshSendState();
    }

    /* მისალმება ჩნდება მხოლოდ ჩატის დაწყების შემდეგ.
       animate === true → იწერება typewriter-ით, ისევე როგორც ადმინის მესიჯი. */
    function ensureWelcomeMessage(animate) {
      if (!chatStarted) return;
      if (body.querySelector('[data-system-initial="true"]')) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'dk-msg support' + (animate ? ' dk-soft-in' : ' dk-no-anim');
      wrapper.setAttribute('data-system-initial', 'true');
      wrapper.innerHTML =
        '<div class="dk-msg-avatar">' +
        '<img src="https://cdn.shopify.com/s/files/1/0865/3530/7574/files/logo_dkhl.png?v=1776697611" alt="Support" />' +
        '</div>' +
        '<div class="dk-bubble dk-message-text">' + esc(initialMessageText) + '</div>';
      body.prepend(wrapper);

      if (animate) {
        // 320ms — სანამ „დაწყების" overlay ქრება
        typewriteElement(wrapper.querySelector('.dk-message-text'), 320);
      }
    }

    function renderEmptyState(animateWelcome) {
      body.innerHTML = '';
      ensureWelcomeMessage(animateWelcome);
      bottom();
    }









function openImageLightbox(src) {
  var allImages = Array.from(body.querySelectorAll('.dk-msg-image'));
  var allSrcs = allImages.map(function(i) { return i.src; });
  var currentIndex = allSrcs.indexOf(src);
  if (currentIndex === -1) { currentIndex = 0; allSrcs = [src]; }

  document.body.style.overflow = 'hidden';

  var overlay = document.createElement('div');
  overlay.style.cssText = [
    'position:fixed',
    'inset:0',
    'z-index:99999',
    'background:rgba(0,0,0,0.88)',
    'backdrop-filter:blur(16px)',
    '-webkit-backdrop-filter:blur(16px)',
    'display:flex',
    'flex-direction:column',
    'align-items:center',
    'justify-content:center',
    'touch-action:none',
  ].join(';');

  var closeBtn = document.createElement('button');
  closeBtn.style.cssText = [
    'position:fixed',
    'top:16px',
    'right:16px',
    'width:34px',
    'height:34px',
    'border-radius:10px',
    'background:#242424',
    'border:1px solid rgba(255,255,255,0.12)',
    'color:#fff',
    'display:flex',
    'align-items:center',
    'justify-content:center',
    'cursor:pointer',
    'z-index:10',
    'padding:0',
    'transition:background 0.15s',
  ].join(';');
  closeBtn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6L18 18M18 6L6 18"/></svg>';
  closeBtn.addEventListener('mouseover', function() { closeBtn.style.background = '#2e2e2e'; });
  closeBtn.addEventListener('mouseout', function() { closeBtn.style.background = '#242424'; });

  var imgContainer = document.createElement('div');
  imgContainer.style.cssText = [
    'position:fixed',
    'top:60px',
    'left:0',
    'right:0',
    'bottom:80px',
    'display:flex',
    'align-items:center',
    'justify-content:center',
    'pointer-events:none',
    'overflow:hidden',
  ].join(';');

  var img = document.createElement('img');
  img.src = allSrcs[currentIndex];
  img.style.cssText = [
    'max-width:80vw',
    'max-height:100%',
    'width:auto',
    'height:auto',
    'object-fit:contain',
    'display:block',
    'border-radius:12px',
    'user-select:none',
    '-webkit-user-select:none',
    'pointer-events:auto',
    'opacity:1',
    'transform:translateX(0) scale(1)',
    'filter:blur(0)',
    'transition:opacity 0.32s cubic-bezier(0.22, 1, 0.36, 1), transform 0.32s cubic-bezier(0.22, 1, 0.36, 1), filter 0.32s cubic-bezier(0.22, 1, 0.36, 1)',
  ].join(';');

  imgContainer.appendChild(img);

  var bottomRow = document.createElement('div');
  bottomRow.style.cssText = [
    'position:fixed',
    'bottom:20px',
    'left:50%',
    'transform:translateX(-50%)',
    'display:flex',
    'align-items:center',
    'justify-content:center',
    'gap:8px',
    'z-index:10',
  ].join(';');

  function makeArrowBtn(svg) {
    var btn = document.createElement('button');
    btn.style.cssText = [
      'width:34px',
      'height:34px',
      'border-radius:10px',
      'background:#242424',
      'border:1px solid rgba(255,255,255,0.1)',
      'color:#fff',
      'display:flex',
      'align-items:center',
      'justify-content:center',
      'cursor:pointer',
      'padding:0',
      'flex-shrink:0',
      'transition:background 0.15s',
    ].join(';');
    btn.innerHTML = svg;
    btn.addEventListener('mouseover', function() { btn.style.background = '#2e2e2e'; });
    btn.addEventListener('mouseout', function() { btn.style.background = '#242424'; });
    return btn;
  }

  var prevBtn = makeArrowBtn('<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>');
  var nextBtn = makeArrowBtn('<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>');

  var counter = document.createElement('div');
  counter.style.cssText = [
    'background:#242424',
    'border:1px solid rgba(255,255,255,0.1)',
    'border-radius:8px',
    'padding:0 12px',
    'height:34px',
    'display:flex',
    'align-items:center',
    'justify-content:center',
    'color:rgba(255,255,255,0.7)',
    'font-size:12px',
    'font-weight:600',
    'min-width:48px',
    'letter-spacing:0.04em',
  ].join(';');

  var isAnimating = false;

  function goTo(index) {
    if (isAnimating || index === currentIndex) return;
    isAnimating = true;

    var direction = index > currentIndex ? 1 : -1;

    img.style.opacity = '0';
    img.style.transform = 'translateX(' + (-22 * direction) + 'px) scale(0.985)';
    img.style.filter = 'blur(8px)';

    setTimeout(function() {
      currentIndex = index;
      img.src = allSrcs[currentIndex];

      img.style.transition = 'none';
      img.style.opacity = '0';
      img.style.transform = 'translateX(' + (22 * direction) + 'px) scale(0.985)';
      img.style.filter = 'blur(8px)';

      img.offsetHeight;

      img.style.transition = 'opacity 0.36s cubic-bezier(0.22, 1, 0.36, 1), transform 0.36s cubic-bezier(0.22, 1, 0.36, 1), filter 0.36s cubic-bezier(0.22, 1, 0.36, 1)';
      img.style.opacity = '1';
      img.style.transform = 'translateX(0) scale(1)';
      img.style.filter = 'blur(0)';

      updateUI();

      setTimeout(function() { isAnimating = false; }, 360);
    }, 220);
  }

  function updateUI() {
    if (allSrcs.length > 1) {
      counter.textContent = (currentIndex + 1) + ' / ' + allSrcs.length;
      prevBtn.style.visibility = currentIndex > 0 ? 'visible' : 'hidden';
      nextBtn.style.visibility = currentIndex < allSrcs.length - 1 ? 'visible' : 'hidden';
      bottomRow.style.display = 'flex';
    } else {
      bottomRow.style.display = 'none';
    }
  }

  prevBtn.onclick = function(e) { e.stopPropagation(); if (currentIndex <= 0) return; goTo(currentIndex - 1); };
  nextBtn.onclick = function(e) { e.stopPropagation(); if (currentIndex >= allSrcs.length - 1) return; goTo(currentIndex + 1); };

  bottomRow.appendChild(prevBtn);
  bottomRow.appendChild(counter);
  bottomRow.appendChild(nextBtn);

  overlay.appendChild(closeBtn);
  overlay.appendChild(imgContainer);
  overlay.appendChild(bottomRow);
  document.body.appendChild(overlay);

  updateUI();

  // swipe
  var touchStartX = 0;
  var touchStartY = 0;

  overlay.addEventListener('touchstart', function(e) {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });

  overlay.addEventListener('touchend', function(e) {
    var deltaX = e.changedTouches[0].clientX - touchStartX;
    var deltaY = e.changedTouches[0].clientY - touchStartY;
    if (Math.abs(deltaX) < Math.abs(deltaY)) return;
    if (Math.abs(deltaX) < 40) return;
    if (deltaX < 0 && currentIndex < allSrcs.length - 1) goTo(currentIndex + 1);
    else if (deltaX > 0 && currentIndex > 0) goTo(currentIndex - 1);
  }, { passive: true });

  function close() {
    document.body.style.overflow = '';
    if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
  }

  closeBtn.onclick = function(e) { e.stopPropagation(); close(); };
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay || e.target === imgContainer) { e.stopPropagation(); close(); }
  });
  overlay.addEventListener('click', function(e) { e.stopPropagation(); });

  document.addEventListener('keydown', function handler(e) {
    if (e.key === 'Escape') { close(); document.removeEventListener('keydown', handler); }
    if (e.key === 'ArrowLeft' && currentIndex > 0) goTo(currentIndex - 1);
    if (e.key === 'ArrowRight' && currentIndex < allSrcs.length - 1) goTo(currentIndex + 1);
  });
}














    function showMessageContextMenu(messageId, sender, wrapper) {
      var existing = body.querySelector('.dk-ctx-menu');
      if (existing) existing.remove();

      var menu = document.createElement('div');
      menu.className = 'dk-ctx-menu';
      menu.style.cssText = [
        'position:absolute',
        sender === 'user' ? 'right:0' : 'left:0',
        'bottom:calc(100% + 4px)',
        'background:#1a201c',
        'border:1px solid rgba(255,255,255,.1)',
        'border-radius:12px',
        'overflow:hidden',
        'box-shadow:0 8px 24px rgba(0,0,0,.4)',
        'z-index:100',
        'min-width:0',
'width:auto',
      ].join(';');

      var btn = document.createElement('button');
      btn.style.cssText = [
        'display:flex',
        'align-items:center',
        'gap:8px',
        'width:100%',
        'padding:10px 14px',
        'background:transparent',
        'border:0',
        'color:#f87171',
        'font-size:13px',
        'font-weight:600',
        'cursor:pointer',
        'white-space:nowrap',
      ].join(';');
      btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg> ' + t('del');

      btn.addEventListener('mouseover', function() { btn.style.background = 'rgba(248,113,113,0.1)'; });
      btn.addEventListener('mouseout', function() { btn.style.background = 'transparent'; });

btn.onclick = function(e) {
  e.stopPropagation();
  menu.remove();
  getMessagesRef().child(messageId).update({
    deleted: true,
    deletedAt: Date.now()
  }).catch(function(err) {
    console.error('Failed to delete message:', err);
  });
};

      menu.appendChild(btn);
      wrapper.style.position = 'relative';
      wrapper.appendChild(menu);

      setTimeout(function() {
        document.addEventListener('click', function handler() {
          menu.remove();
          document.removeEventListener('click', handler);
        });
      }, 0);
    }



function renderMessage(messageId, message) {
  if (!message || renderedMessageIds.has(messageId)) return;

  var senderClass = message.sender === 'admin' ? 'support' : 'user';
  var wrapper = document.createElement('div');
  // ჩატვირთვისას ანიმაცია ითიშება — ათეულობით პარალელური ანიმაცია ჭედავს
  wrapper.className = 'dk-msg ' + senderClass + (initialRenderBatch ? ' dk-no-anim' : '');
  wrapper.setAttribute('data-message-id', messageId);

  var hasImage = !!message.imageUrl;
  var hasText = !!(message.text && String(message.text).trim());
  var isLocation = !!message.isLocation;
  var isProduct = !!message.isProduct && !!message.product;

if (message.deleted) {
    var bubbleHTML = '<div class="dk-bubble dk-deleted-bubble">' +
      '<span class="dk-deleted-text">' + t('deleted') + '</span>' +
      '</div>';

    if (message.sender === 'admin') {
      wrapper.innerHTML = '<div class="dk-msg-avatar"><img src="https://cdn.shopify.com/s/files/1/0865/3530/7574/files/logo_dkhl.png?v=1776697611" alt="Support" /></div>' + bubbleHTML;
    } else {
      wrapper.innerHTML = bubbleHTML;
    }

    body.appendChild(wrapper);
    renderedMessageIds.add(messageId);

    ensureWelcomeMessage();
    bottom();
    return;
  }

  var bubbleHTML = '';
  if (isProduct) {
    bubbleHTML = '<div class="dk-bubble dk-product-bubble"></div>';
  } else if (isLocation) {
    bubbleHTML = '<div class="dk-bubble dk-location-bubble"></div>';
} else if (hasImage) {
  bubbleHTML =
    '<div class="dk-bubble dk-image-bubble' + (hasText ? ' dk-has-text' : '') + '">' +
    '<img class="dk-msg-image" src="' + esc(message.imageUrl) + '" alt="Attachment" loading="lazy" decoding="async" style="cursor:pointer;" />' +
    '</div>';
} else {
  bubbleHTML = '<div class="dk-bubble dk-message-text"></div>';
}

  if (message.sender === 'admin') {
    wrapper.innerHTML =
      '<div class="dk-msg-avatar">' +
      '<img src="https://cdn.shopify.com/s/files/1/0865/3530/7574/files/logo_dkhl.png?v=1776697611" alt="Support" />' +
      '</div>' +
      bubbleHTML;
  } else {
    wrapper.innerHTML = bubbleHTML;
  }

  /* ─── პროდუქტის ბარათი ─────────────────────────────────── */
  if (isProduct) {
    var p = message.product || {};
    var rawUrl = typeof p.url === 'string' ? p.url : '';
    var safeUrl = isSafeLinkHref(rawUrl) ? rawUrl : '';
    var priceText = formatProductPrice(p.price, p.currency);
    var productTitle = p.title || '';
    var imageSrc = typeof p.image === 'string' ? p.image : '';

    var productBubble = wrapper.querySelector('.dk-product-bubble');
    if (productBubble) {
      var openTag = safeUrl
        ? '<a class="dk-product-card" href="' + esc(safeUrl) + '" target="_blank" rel="noopener noreferrer nofollow">'
        : '<div class="dk-product-card">';
      var closeTag = safeUrl ? '</a>' : '</div>';

      productBubble.innerHTML =
        openTag +
          (imageSrc
            ? '<div class="dk-product-media">' +
                '<img src="' + esc(imageSrc) + '" alt="' + esc(productTitle) + '" loading="lazy" decoding="async" />' +
              '</div>'
            : '') +
          '<div class="dk-product-info">' +
            '<div class="dk-product-title">' + esc(productTitle) + '</div>' +
            (priceText || safeUrl
              ? '<div class="dk-product-row">' +
                  '<span class="dk-product-price">' + esc(priceText) + '</span>' +
                  '<span class="dk-product-arrow">' +
                    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">' +
                      '<path d="M7 17L17 7M17 7H7M17 7v10"/>' +
                    '</svg>' +
                  '</span>' +
                '</div>'
              : '') +
          '</div>' +
        closeTag;

      var productLink = productBubble.querySelector('a.dk-product-card');
      if (productLink) {
        productLink.addEventListener('click', function(e) { e.stopPropagation(); });
      }
    }
  }

  if (!isLocation && !isProduct && hasText) {
  if (hasImage) {
    var imageBubble = wrapper.querySelector(".dk-image-bubble");
    if (imageBubble) {
      imageBubble.appendChild(createLinkifiedDiv("dk-msg-caption", message.text));
    }
  } else {
    var textBubble = wrapper.querySelector(".dk-message-text");
    if (textBubble) {
      linkifyTextInto(textBubble, message.text);
    }
  }
}

if (isLocation) {
    var bubble = wrapper.querySelector('.dk-location-bubble');
    if (bubble) {
      bubble.innerHTML =
        '<a href="https://maps.app.goo.gl/BKcYLs8vUB8vuBoEA" target="_blank" rel="noopener noreferrer" class="dk-map-card">' +
          '<div class="dk-map-visual">' +
            '<img src="https://cdn.shopify.com/s/files/1/0865/3530/7574/files/map.png?v=1778763060" ' +
              'alt="Tbilisi Mall" ' +
              'style="width:100%;height:100%;object-fit:cover;display:block;" />' +
          '</div>' +
          '<div class="dk-map-info-row">' +
            '<div class="dk-map-pin-icon">' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1ea866" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">' +
                '<path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>' +
                '<circle cx="12" cy="9" r="2.5"/>' +
              '</svg>' +
            '</div>' +
            '<div class="dk-map-texts">' +
              '<div class="dk-map-title">' + t('mapTitle') + '</div>' +
              '<div class="dk-map-subtitle">' + t('mapSubtitle') + '</div>' +
            '</div>' +
            '<svg class="dk-map-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
              '<path d="M7 17L17 7M17 7H7M17 7v10"/>' +
            '</svg>' +
          '</div>' +
        '</a>';
    }
  }

  var bubble = wrapper.querySelector('.dk-bubble');
  if (bubble) {
    var pressTimer = null;

bubble.addEventListener('touchstart', function() {
  if (message.sender !== 'user') return;
  pressTimer = setTimeout(function() {
    showMessageContextMenu(messageId, message.sender, wrapper);
  }, 500);
});
    bubble.addEventListener('touchend', function() { clearTimeout(pressTimer); });
    bubble.addEventListener('touchmove', function() { clearTimeout(pressTimer); });

bubble.addEventListener('contextmenu', function(e) {
  e.preventDefault();
  if (message.sender === 'user') {
    showMessageContextMenu(messageId, message.sender, wrapper);
  }
});
  }

  var msgImg = wrapper.querySelector('.dk-msg-image');
  if (msgImg) {
    msgImg.addEventListener('click', function(e) {
      e.stopPropagation();
      openImageLightbox(msgImg.src);
    });

    var touchStartX = 0;
    var touchStartY = 0;

    msgImg.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });

    msgImg.addEventListener('touchend', function(e) {
      var deltaX = Math.abs(e.changedTouches[0].clientX - touchStartX);
      var deltaY = Math.abs(e.changedTouches[0].clientY - touchStartY);
      if (deltaX > 8 || deltaY > 8) return;
      e.stopPropagation();
      openImageLightbox(msgImg.src);
    }, { passive: true });
  }

  body.appendChild(wrapper);
  renderedMessageIds.add(messageId);

    // typewriter — მხოლოდ ჩვეულებრივ ტექსტზე (ბარათებზე არა)
    if (initialLoadDone && message.sender === 'admin' && !isLocation && !isProduct) {
    typewriteElement(wrapper.querySelector('.dk-msg-caption') || wrapper.querySelector('.dk-message-text'));
  }

  ensureWelcomeMessage();
  bottom();
}

    function updateSeenBadge(adminSeenAt) {
      var existing = body.querySelector('.dk-seen-row');
      if (existing) existing.remove();

      var hasUserMessage = !!body.querySelector('.dk-msg.user');
      if (!hasUserMessage) return;

      if (!adminSeenAt || !lastSentAt || adminSeenAt < lastSentAt) return;

      var userMsgs = body.querySelectorAll('.dk-msg.user');
      var lastUserMsg = userMsgs[userMsgs.length - 1];
      if (!lastUserMsg) return;

      var row = document.createElement('div');
      row.className = 'dk-seen-row';
      row.innerHTML =
        '<div class="dk-seen-inner">' +
        '<span class="dk-seen-label">' + t('seen') + '</span>' +
        '<img class="dk-seen-avatar" src="https://cdn.shopify.com/s/files/1/0865/3530/7574/files/logo_dkhl.png?v=1776697611" alt="Seen" />' +
        '</div>';
      lastUserMsg.insertAdjacentElement('afterend', row);
      bottom();
    }

    function updateAdminTypingIndicator(isTyping) {
      var existing = body.querySelector('.dk-typing-indicator');
      if (existing) existing.remove();
      if (!isTyping) return;

var el = document.createElement('div');
el.className = 'dk-msg support dk-typing-indicator';
el.innerHTML =
  '<div class="dk-msg-avatar">' +
  '<img src="https://cdn.shopify.com/s/files/1/0865/3530/7574/files/logo_dkhl.png?v=1776697611" alt="Support" />' +
  '</div>' +
  '<div class="dk-bubble dk-message-text dk-typing-bubble">' +
  '<span class="dk-dot"></span>' +
  '<span class="dk-dot"></span>' +
  '<span class="dk-dot"></span>' +
  '</div>';
      body.appendChild(el);
      bottom();
    }

    function markVisitorRead() {
      getMetaRef().update({
        visitorUnread: false,
        visitorSeenAt: Date.now()
      }).catch(function(error) {
        console.error('Failed to mark visitor read:', error);
      });
    }

    function buildMeta(lastMessageText, senderRole) {
      var now = Date.now();
      return {
        sessionId: sessionId,
        source: 'shopify',
        visitorName: visitorName,
        adminUnread: senderRole === 'user',
        visitorUnread: senderRole === 'admin',
        lastMessage: lastMessageText,
        lastSender: senderRole,
        adminSeenAt: null,
        createdAt: now,
        updatedAt: now,
        status: 'open',
        pageUrl: window.location.href,
        pageTitle: document.title || '',
        userAgent: navigator.userAgent || '',
        locale: DK_LANG
      };
    }

    function updateMetaAfterSend(lastMessageText, senderRole) {
      var now = Date.now();
      return getMetaRef().once('value')
        .then(function(snapshot) {
          var existing = snapshot.val() || {};
          return getMetaRef().update({
            sessionId: sessionId,
            source: 'shopify',
            visitorName: visitorName,
            adminUnread: senderRole === 'user' ? true : !!existing.adminUnread,
            visitorUnread: senderRole === 'admin' ? true : false,
            lastMessage: lastMessageText,
            lastSender: senderRole,
            createdAt: existing.createdAt || now,
            adminSeenAt: senderRole === 'user' ? null : (existing.adminSeenAt || null),
            updatedAt: now,
            status: existing.status || 'open',
            pageUrl: window.location.href,
            pageTitle: document.title || '',
            userAgent: navigator.userAgent || '',
            locale: DK_LANG
          });
        })
        .catch(function(error) {
          console.error('Meta update failed:', error);
        });
    }

    function notifyMessage(text, imageUrl, createdAt) {
      return fetch('https://dashboard.dakhli.ge/api/website-chat/notify-message', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sessionId: sessionId,
          visitorName: visitorName,
          messageText: text || '',
          imageUrl: imageUrl || '',
          hasImage: !!imageUrl,
          pageUrl: window.location.href,
          pageTitle: document.title || '',
          createdAt: createdAt,
          locale: DK_LANG
        })
      })
      .then(function(res) {
        return res.json().catch(function() { return {}; }).then(function(data) {
          if (!res.ok) console.error('notify-message failed:', data);
        });
      })
      .catch(function(err) {
        console.error('notify-message request failed:', err);
      });
    }

function uploadToCloudinary(base64) {
  var arr = base64.split(',');
  var mime = (arr[0].match(/:(.*?);/) || [])[1] || 'image/jpeg';
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) u8arr[n] = bstr.charCodeAt(n);
  var blob = new Blob([u8arr], { type: mime });

  var formData = new FormData();
  formData.append('file', blob, 'image.jpg');
  formData.append('upload_preset', 'DKHLSITE');
  formData.append('folder', 'website-chats');

  return fetch('https://api.cloudinary.com/v1_1/dwfpjmnpo/image/upload', {
    method: 'POST',
    body: formData
  })
  .then(function(res) { return res.json(); })
  .then(function(data) {
    if (!data.secure_url) throw new Error('Cloudinary upload failed');
    return data.secure_url;
  });
}

function sendMessage() {
  if (isBlocked) return;
  if (!chatStarted) return;
  var text = input.value.trim();
  if (!text && selectedImageData.length === 0) return;

  var now = Date.now();
  lastSentAt = now;
localStorage.setItem('dk_chat_last_sent_at', now);
  clearTimeout(typingTimeout);
  typingLastSent = 0;
  getMetaRef().update({ visitorTyping: false }).catch(function() {});

  var imagesToSend = selectedImageData.slice();
  input.value = '';
  input.style.height = 'auto';
  clearImagePreview();
  refreshSendState();

  if (imagesToSend.length === 0) {
    // ტექსტი მხოლოდ
    var ref = getMessagesRef().push();
    var payload = { text: text, sender: 'user', createdAt: now, sessionId: sessionId, visitorName: visitorName };
    ref.set(payload)
      .then(function() { return updateMetaAfterSend(text, 'user'); })
      .then(function() { return notifyMessage(text, null, now); })
      .catch(function(error) { console.error('Failed to send:', error); });
    return;
  }

  // ფოტოების გაგზავნა თანმიმდევრულად
  var loadingEl = document.createElement('div');
  loadingEl.className = 'dk-msg user';
  loadingEl.innerHTML = '<div style="width:20px;height:20px;border-radius:50%;border:2px solid rgba(255,255,255,0.15);border-top-color:#1ea866;animation:dkSpin 0.7s linear infinite;"></div>';
  body.appendChild(loadingEl);
  bottom();

  var uploadPromises = imagesToSend.map(function(base64) {
    return uploadToCloudinary(base64);
  });

  Promise.all(uploadPromises).then(function(urls) {
    if (loadingEl.parentNode) loadingEl.parentNode.removeChild(loadingEl);

    var sendChain = Promise.resolve();
    urls.forEach(function(imageUrl, i) {
      sendChain = sendChain.then(function() {
        var msgText = (i === 0) ? text : '';
        var ref = getMessagesRef().push();
        var payload = { text: msgText, sender: 'user', createdAt: now + i, sessionId: sessionId, visitorName: visitorName, imageUrl: imageUrl };
        return ref.set(payload);
      });
    });

    return sendChain
      .then(function() { return updateMetaAfterSend(text || '📷 Image', 'user'); })
      .then(function() { return notifyMessage(text, urls[0], now); });

  }).catch(function(error) {
    if (loadingEl.parentNode) loadingEl.parentNode.removeChild(loadingEl);
    console.error('Failed to send:', error);
  });
}

    function loadInitialMessages(animateWelcome) {
      initialLoadDone = false;

      getMessagesRef().orderByChild('createdAt').limitToLast(50).once('value')
        .then(function(snapshot) {
          renderedMessageIds = new Set();
          renderEmptyState(animateWelcome);

          if (!snapshot.exists()) {
            initialLoadDone = true;
            return;
          }

          var messages = snapshot.val() || {};
          var entries = Object.entries(messages).sort(function(a, b) {
            var aTime = a[1] && a[1].createdAt ? a[1].createdAt : 0;
            var bTime = b[1] && b[1].createdAt ? b[1].createdAt : 0;
            return aTime - bTime;
          });

          initialRenderBatch = true;
          entries.forEach(function(entry) {
            renderMessage(entry[0], entry[1]);
          });
          initialRenderBatch = false;

          ensureWelcomeMessage();
          initialLoadDone = true;
          bottom();
        })
        .catch(function(error) {
          console.error('Failed to load messages:', error);
          initialRenderBatch = false;
          renderEmptyState();
          initialLoadDone = true;
        });
    }

    function detachListeners() {
  if (messagesListenerAttached) {
    getMessagesRef().off('child_added');
    getMessagesRef().off('child_changed');
    getMessagesRef().off('child_removed');
    messagesListenerAttached = false;
  }
      if (metaListenerAttached) {
        getMetaRef().off();
        metaListenerAttached = false;
      }
    }

    function subscribeToMessages() {
      getMessagesRef().orderByChild('createdAt').limitToLast(50).on('child_added', function(snapshot) {
        if (!initialLoadDone) return;
        renderMessage(snapshot.key, snapshot.val());
      });

getMessagesRef().on('child_changed', function(snapshot) {
  if (!initialLoadDone) return;
  var existingWrapper = body.querySelector('[data-message-id="' + snapshot.key + '"]');
  if (existingWrapper && snapshot.val().deleted) {
    existingWrapper.innerHTML = '<div class="dk-bubble dk-deleted-bubble"><span class="dk-deleted-text">' + t('deleted') + '</span></div>';
    if (snapshot.val().sender === 'admin') {
      existingWrapper.innerHTML = '<div class="dk-msg-avatar"><img src="https://cdn.shopify.com/s/files/1/0865/3530/7574/files/logo_dkhl.png?v=1776697611" alt="Support" /></div><div class="dk-bubble dk-deleted-bubble"><span class="dk-deleted-text">' + t('deleted') + '</span></div>';
    }
  } else if (existingWrapper) {
    existingWrapper.remove();
    renderedMessageIds.delete(snapshot.key);
    renderMessage(snapshot.key, snapshot.val());
  }
});

      getMessagesRef().on('child_removed', function(snapshot) {
        var wrapper = body.querySelector('[data-message-id="' + snapshot.key + '"]');
        if (wrapper) wrapper.remove();
      });

      messagesListenerAttached = true;
    }

    function subscribeToMeta() {
      getMetaRef().on('value', function(snapshot) {
        var meta = snapshot.val();

        if (!meta) {
          if (chatStarted) {
            input.value = '';
            input.style.height = 'auto';
            clearImagePreview();
            setChatStarted(false);
            renderedMessageIds = new Set();
            renderEmptyState();
            detachListeners();
lastSentAt = null;
localStorage.removeItem('dk_chat_last_sent_at');

var newSessionId = generateSessionId();
            sessionId = newSessionId;
            localStorage.setItem(STORAGE_KEYS.sessionId, newSessionId);
            localStorage.removeItem(STORAGE_KEYS.started);
          }
          return;
        }

        if (panel.classList.contains('active') && meta.visitorUnread && meta.lastSender === 'admin') {
          markVisitorRead();
        }

        updateSeenBadge(meta.adminSeenAt);
        updateAdminTypingIndicator(meta.adminTyping);
      });
      metaListenerAttached = true;
    }

    function attachListenersForCurrentSession() {
      detachListeners();
      subscribeToMessages();
      subscribeToMeta();
    }



function closePanelOnly() {
  clearTimeout(openWorkTimer);
  panel.classList.remove('active');
  root.classList.remove('dk-open');
  document.body.style.overflow = '';
  hideEndOverlay();
  detachListeners();
}

    function closeChat() {
      var now = Date.now();

      getMetaRef().once('value')
        .then(function(snapshot) {
          var existing = snapshot.val() || {};
          return getMetaRef().update({
            sessionId: sessionId,
            source: 'shopify',
            visitorName: visitorName,
            adminUnread: false,
            visitorUnread: false,
            lastMessage: existing.lastMessage || t('chatClosed'),
            lastSender: existing.lastSender || 'user',
            createdAt: existing.createdAt || now,
            updatedAt: now,
            closedAt: now,
            status: 'closed',
            pageUrl: window.location.href,
            pageTitle: document.title || '',
            userAgent: navigator.userAgent || '',
            locale: DK_LANG
          });
        })
        .then(function() {
          input.value = '';
          input.style.height = 'auto';
          clearImagePreview();
          hideEndOverlay();
          setChatStarted(false);
          panel.classList.remove('active');
          root.classList.remove('dk-open');
          document.body.style.overflow = '';
          renderedMessageIds = new Set();
          renderEmptyState();
          detachListeners();

         var newSessionId = generateSessionId();
sessionId = newSessionId;
localStorage.setItem(STORAGE_KEYS.sessionId, newSessionId);
localStorage.removeItem('dk_chat_last_sent_at');
lastSentAt = null;
        })
        .catch(function(error) {
          console.error('Failed to close chat:', error);
        });
    }



trigger.onclick = function() {
  if (isBlocked) return;

  panel.classList.toggle('active');
  var isOpen = panel.classList.contains('active');
  root.classList.toggle('dk-open', isOpen);

  clearTimeout(openWorkTimer);

  if (isOpen) {
    hideEndOverlay();

    /* Firebase-ის ჩატვირთვა, listener-ები და 50 მესიჯის დახატვა
       გახსნის ანიმაციის შემდეგ სრულდება — თორემ ეს ყველაფერი
       ზუსტად ანიმაციის დროს იტვირთებოდა და ჭედავდა. */
    openWorkTimer = setTimeout(function() {
      if (!panel.classList.contains('active')) return;

      if (chatStarted) {
        loadInitialMessages();
        attachListenersForCurrentSession();
        markVisitorRead();
        input.focus();
      }

      autoResize();
      bottom();
    }, 380);
  } else {
    root.classList.remove('dk-open');
    document.body.style.overflow = '';
    detachListeners();
  }
};

    close.onclick = function() {
      showEndOverlay();
    };

    startBtn.onclick = function() {
      if (isBlocked) return;

      getMetaRef().once('value').then(function(snap) {
        if (!snap.exists()) {
          getMetaRef().set(buildMeta(initialMessageText, 'admin'));
        }
      });

      setChatStarted(true);
      loadInitialMessages(true);
      attachListenersForCurrentSession();
      markVisitorRead();

      setTimeout(function() {
        input.focus();
        autoResize();
        bottom();
      }, 120);
    };

    send.onclick = sendMessage;



    plus.onclick = function() {
      if (isBlocked) return;
      if (!chatStarted) return;
      fileInput.click();
    };

    // ✅ shared image processor — used by file input, paste, and drag&drop
    function processFiles(fileList) {
      if (isBlocked) return;

      var files = Array.from(fileList || []).filter(function(f) {
        return f.type && f.type.startsWith('image/');
      });
      if (!files.length) return;

      var remaining = 20 - selectedImageData.length;
      if (remaining <= 0) {
        alert(t('maxPhotos'));
        return;
      }

      var toLoad = files.slice(0, remaining);

      toLoad.forEach(function(file) {
        if (file.size > 5 * 1024 * 1024) {
          alert(t('tooLarge') + file.name);
          return;
        }
        var reader = new FileReader();
        reader.onload = function() {
          selectedImageData.push(reader.result);
          addImageThumb(reader.result, selectedImageData.length - 1);
          uploadPreview.classList.remove('hidden');
          refreshSendState();
        };
        reader.readAsDataURL(file);
      });
    }

    // ✅ file validation + size check
fileInput.addEventListener('change', function() {
  processFiles(fileInput.files);
  fileInput.value = '';
});

    // ✅ paste images from clipboard (Ctrl/Cmd+V)
    input.addEventListener('paste', function(e) {
      if (isBlocked) return;
      if (!chatStarted) return;
      var items = Array.from((e.clipboardData && e.clipboardData.items) || []);
      var imageFiles = items
        .filter(function(item) { return item.kind === 'file' && item.type.indexOf('image/') === 0; })
        .map(function(item) { return item.getAsFile(); })
        .filter(function(f) { return !!f; });

      if (imageFiles.length > 0) {
        e.preventDefault();
        processFiles(imageFiles);
      }
    });

    // ✅ drag & drop images anywhere onto the open chat panel
    var dragCounter = 0;

    panel.addEventListener('dragover', function(e) {
      if (isBlocked) return;
      if (!chatStarted) return;
      if (!e.dataTransfer || !e.dataTransfer.types || e.dataTransfer.types.indexOf('Files') === -1) return;
      e.preventDefault();
    });

    panel.addEventListener('dragenter', function(e) {
      if (isBlocked) return;
      if (!chatStarted) return;
      if (!e.dataTransfer || !e.dataTransfer.types || e.dataTransfer.types.indexOf('Files') === -1) return;
      e.preventDefault();
      dragCounter++;
      dragOverlay.classList.add('active');
    });

    panel.addEventListener('dragleave', function(e) {
      if (!chatStarted) return;
      dragCounter = Math.max(0, dragCounter - 1);
      if (dragCounter === 0) dragOverlay.classList.remove('active');
    });

    panel.addEventListener('drop', function(e) {
      if (isBlocked) return;
      if (!chatStarted) return;
      if (!e.dataTransfer || !e.dataTransfer.files) return;
      e.preventDefault();
      dragCounter = 0;
      dragOverlay.classList.remove('active');
      processFiles(e.dataTransfer.files);
    });



    endYes.onclick = closeChat;
    endNo.onclick = function() {
      closePanelOnly();
    };

    input.addEventListener('input', autoResize);

    // ✅ typing throttle — 500ms-ში ერთხელ წერს Firebase-ში
    input.addEventListener('input', function() {
      if (isBlocked) return;
      if (!chatStarted) return;
      var now = Date.now();
      if (now - typingLastSent > 500) {
        typingLastSent = now;
        getMetaRef().update({ visitorTyping: true }).catch(function() {});
      }
      clearTimeout(typingTimeout);
      typingTimeout = setTimeout(function() {
        typingLastSent = 0;
        getMetaRef().update({ visitorTyping: false }).catch(function() {});
      }, 2000);
    });

    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        sendMessage();
      }
    });

    document.addEventListener('click', function(e) {
      if (!root.contains(e.target)) {
        closePanelOnly();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        if (endOverlay.classList.contains('active')) {
          hideEndOverlay();
        } else {
          closePanelOnly();
        }
      }
    });

// drag-to-scroll preview
var previewScroll = document.getElementById('dkUploadPreviewScroll');
var psDragging = false;
var psStartX = 0;
var psScrollLeft = 0;
var psMoved = false;

previewScroll.addEventListener('mousedown', function(e) {
  if (e.button !== 0) return;
  psDragging = true;
  psMoved = false;
  psStartX = e.clientX;
  psScrollLeft = previewScroll.scrollLeft;
  previewScroll.style.userSelect = 'none';
  previewScroll.style.cursor = 'grabbing';
  e.preventDefault();
});

window.addEventListener('mousemove', function(e) {
  if (!psDragging) return;
  var dx = e.clientX - psStartX;
  if (Math.abs(dx) > 3) psMoved = true;
  previewScroll.scrollLeft = psScrollLeft - dx;
});

window.addEventListener('mouseup', function() {
  if (!psDragging) return;
  psDragging = false;
  previewScroll.style.userSelect = '';
  previewScroll.style.cursor = 'grab';
});

previewScroll.addEventListener('click', function(e) {
  if (psMoved) {
    e.stopPropagation();
    e.preventDefault();
    psMoved = false;
  }
});

updateWorkingHoursStatus();
setInterval(updateWorkingHoursStatus, 60000);
    renderEmptyState();
    setChatStarted(chatStarted);
    refreshSendState();

    /* ─── ბლოკის მდგომარეობის მოსმენა ──────────────────────────
       ორ გასაღებზე: visitorName (მდგრადი) და sessionId (მიმდინარე).
       ვიჯეტი მხოლოდ პირველი შემოწმების შემდეგ ჩნდება,
       რომ დაბლოკილს წამითაც არ დაენახოს.                       */
    var blockedByName = false;
    var blockedBySession = false;

    function refreshBlockState() {
      applyBlockState(blockedByName || blockedBySession);
      if (!isBlocked) trigger.style.visibility = 'visible';
    }

    db.ref('blockedVisitors/' + blockKey(visitorName)).on('value', function(snap) {
      blockedByName = snap.exists() && snap.val() !== false;
      refreshBlockState();
    }, function(error) {
      console.error('Block state read failed (name):', error);
      trigger.style.visibility = 'visible';
    });

    db.ref('blockedSessions/' + blockKey(sessionId)).on('value', function(snap) {
      blockedBySession = snap.exists() && snap.val() !== false;
      refreshBlockState();
    }, function(error) {
      console.error('Block state read failed (session):', error);
      trigger.style.visibility = 'visible';
    });
  }
})();